// src/data/products.js
const products = [
  // Cosmetics
  {
    id: 1,
    category: "skin-care",
    slug: "jojoba-r-anti-fungal-cream",
    images: [
      "/assets/products/anti_fungal.jpg",
      "/assets/products/anti_fungal_features.png",
    ],
    image: "/assets/products/anti_fungal.webp",
    banner: "/assets/banners/anti_fungal.png",
    name: "Jojoba R Anti Fungal Cream",
    description: "A natural solution for soothing and healing skin fungal infections.",
    features: [
      { icon: "fa-bacteria", title: "Treats Fungal Infection", text: "Fast-Acting Formula That Targets Root Cause." },
      { icon: "fa-hand-dots", title: "Reduces Itching and Redness", text: "Provides Instant Relief and Skin Comfort." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Gentle, Plant-Based Actives for Safe Healing." },
      { icon: "fa-hand-sparkles", title: "Soothes Skin", text: "Calms Irritation and Restores Skin Balance." }
    ],
    size: '30gm Tube',
    ingredients: "Echinacea Oil, Calendula Oil, Sarsaparila Oil, Thuja extract, Chalmoga Oil, Occimum Can Oil, Carica Papaya",
    suitableFor: "All Skin Types",
    composition: [
      { name: "Echinacea Oil", amount: "2%" },
      { name: "Calendula Oil", amount: "2%" },
      { name: "Sarsaparilla Oil", amount: "1%" },
      { name: "Thuja Extract", amount: "1%" },
      { name: "Chalmoga Oil", amount: "2%" },
      { name: "Occimum Can Oil", amount: "0.5%" },
      { name: "Carica Papaya", amount: "0.5%" },
      { name: "Cream Base", amount: "qs" }
    ],
    usage: {
      type: "steps",
      steps: [
        { step: "Cleanse", description: "Wash the affected area with mild soap and dry gently." },
        { step: "Apply", description: "Apply a small quantity of cream on the affected area or as directed by the physician." },
      ]
    },
    about: "Jojoba R Anti-Fungal Cream is a fast-absorbing, non-greasy emollient with anti-fungal, anti-inflammatory, and anti-microbial properties. It helps relieve itchy, dry, cracked, or inflamed skin while soothing conditions like eczema, dermatitis, and fungal infections of the skin and mucous membranes. The cream nourishes, moisturizes, and protects the skin, promoting overall skin health and preventing further damage.",

  },
  {
    id: 2,
    category: "cosmetics",
    slug: "jojoba-r-anti-dandruff-shampoo",
    images: [
      "/assets/products/anti_dandruff.jpg",
      "/assets/products/anti_dandruff_2.png"
    ],
    image: "/assets/products/anti_dandruff.webp",
    banner: "/assets/banners/anti_dandruff.png",
    name: "Jojoba R Anti Dandruff Shampoo",
    description: "Advanced Scalp Purifying Anti Dandruff Formula",
    size: '100ml Bottle',
    ingredients: "Amla extract, Brahmi extract, Bhringraj extract, Calendula extract, Cantharis mother tincture, Echinacea extract, Henna extract, Hibiscus extract, Methi extract, Neelambarai extract, Onion extract, Reetha extract, Shikakai extract",
    suitableFor: "All Hair Types",
    features: [
      { icon: "fa-star-of-life", title: "Treats Dandruff", text: "Targets Flakes for a Clear, Healthy Scalp." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Gentle, Plant-Based Formula for Daily Care." },
      { icon: "fa-droplet", title: "Prevents Dryness", text: "Nourishes Scalp to Lock In Moisture." },
      { icon: "fa-star-of-life", title: "Prevents Hair Fall", text: "Strengthens Roots for Reduced Breakage." }
    ],
    usage: {
      type: "steps",
      steps: [
        { step: "Wet", description: "Wet the scalp with water." },
        { step: "Apply", description: "Apply generously to wet hairs." },
        { step: "Massage", description: "Massage into lather from scalp to the ends." },
        { step: "Rinse", description: "Rinse thoroughly with water." },
      ]
    },
    composition: [
      { name: "Amla Extract", amount: "qs" },
      { name: "Brahmi Extract", amount: "qs" },
      { name: "Bhringraj Extract", amount: "qs" },
      { name: "Calendula Extract", amount: "qs" },
      { name: "Cantharis Mother Tincture", amount: "qs" },
      { name: "Echinacea Extract", amount: "qs" },
      { name: "Henna Extract", amount: "qs" },
      { name: "Hibiscus Extract", amount: "qs" },
      { name: "Methi Extract", amount: "qs" },
      { name: "Neelambarai Extract", amount: "qs" },
      { name: "Onion Extract", amount: "qs" },
      { name: "Reetha Extract", amount: "qs" },
      { name: "Shikakai Extract", amount: "qs" }
    ],
    about:"Jojoba R Anti-Dandruff Shampoo gently removes dandruff while nourishing and strengthening hair roots to promote a healthy scalp and hair growth. Enriched with natural ingredients and active moisturizers, it targets dryness and controls dandruff-causing microbes like Malassezia. The shampoo soothes itching, flaking, redness, and irritation, while providing gentle cleansing and long-lasting freshness—leaving hair soft, shiny, and full of natural bounce."
  },
  {
    id: 3,
    category: "skin-care",
    slug: "jojoba-r-anti-psoriasis-cream",
    images: [
      "/assets/products/anti_psoriasis.jpg",
    ],
    image: "/assets/products/anti_psoriasis.webp",
    banner: "/assets/banners/anti_psoriasis.png",
    name: "Jojoba R Anti Psoriasis Cream",
    description: "A natural solution for soothing and healing psoriasis symptoms.",
    size: '50gm Jar',
    ingredients: "Salix alba Extract, Echinacea Extract, Organic Tamanu Oil, Coconut Oil....",
    suitableFor: "Sensitive Skin",
    features: [
      { icon: "fa-star", title: "Reduces Inflammation", text: "Helps calm irritated skin by soothing swelling and discomfort." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Formulated with plant-based, gentle ingredients for safe daily use." },
      { icon: "fa-hand-dots", title: "Reduces itching & Redness", text: "Quickly relieves itchiness and visibly minimizes redness." },
      { icon: "fa-hand-sparkles", title: "Softens Skin", text: "Deeply moisturizes to leave skin smoother, softer, and well-nourished." }
    ],
    composition: [
      { name: "Salix alba Extract", amount: "5%" },
      { name: "Echinacea Extract", amount: "3%" },
      { name: "Organic Tamanu Oil", amount: "3%" },
      { name: "Coconut Oil", amount: "2%" },
      { name: "Carnauba Wax", amount: "2%" },
      { name: "Candelilla Wax", amount: "8%" },
      { name: "Shea Butter", amount: "5%" },
      { name: "Cocoa Butter", amount: "2%" },
      { name: "Natural Vitamin-E", amount: "1%" },
      { name: "Grape Seed Oil", amount: "2%" },
      { name: "Cranberry Seed Oil", amount: "3%" },
      { name: "Raspberry Seed Oil", amount: "3%" },
      { name: "Jojoba Oil", amount: "2%" },
      { name: "Argan Oil", amount: "3%" },
      { name: "Jasmine Flower Extract", amount: "3%" },
      { name: "Cream Base", amount: "qs" }
    ],
    usage: {
      type: "steps",
      steps: [
        { step: "Cleanse", description: "Wash the affected area with mild soap and dry gently." },
        { step: "Apply", description: "Gently Apply the cream two to three times daily." },
        { step: "Massage", description: "Massage gently in circular motions until absorbed." }
      ]
    },
    about: "Jojoba R Anti-Psoriasis Cream is specially formulated with Salix alba, cranberry and raspberry seed extracts, along with organic oils, to treat scaling and inflammation associated with psoriasis. It provides quick relief from itching, redness, and skin build-up, helping soothe and restore irritated skin.",
  },
  {
    id: 4,
    category: "cosmetics",
    slug: "jojoba-r-rejuvenating-face-wash",
    images: [
      "/assets/products/rejuvenating_facewash.jpg",
    ],
    image: "/assets/products/rejuvenating_facewash.webp",
    banner: "/assets/banners/rejuvenating_face_wash.png",
    name: "Jojoba R Rejuvenating Face Wash",
    description: "Deep-cleans the skin while soothing, hydrating, and brightening the face for a fresh, natural glow.",
    size: '50ml Tube',
    ingredients: "Aloevera leaf juice, Honey, Neem extract, Cucumber extract....",
    suitableFor: "All Skin Types",
    features: [
      { icon: "fa-star", title: "Improves Complexion", text: "Enhances skin tone for a brighter, more even appearance." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Made with gentle, plant-based ingredients safe for daily use." },
      { icon: "fa-hand-dots", title: "Reduces Scars & Spots", text: "Helps fade marks and pigmentation for clearer-looking skin." },
      { icon: "fa-droplet", title: "Moisturises Skin", text: "Deeply hydrates to keep skin soft, smooth, and nourished." }
    ],
    composition: [
      { name: "Aloe Vera Leaf Juice", amount: "2%" },
      { name: "Honey (Mel)", amount: "1%" },
      { name: "Neem Extract", amount: "0.5%" },
      { name: "Calendula Extract", amount: "0.5%" },
      { name: "Cucumber Extract", amount: "0.5%" },
      { name: "Bitter Orange Peel Extract", amount: "0.5%" },
      { name: "Red Sandalwood Extract", amount: "0.1%" },
      { name: "Distilled Orange Blossom Water", amount: "—" },
      { name: "Purified Water (Aqua)", amount: "—" }
    ],
    about: "Jojoba R Rejuvenating Face Wash deeply cleanses the skin by removing dirt, excess oil, and impurities, while hydrating and soothing the face for a natural glow. Its balanced formula combines the healing power of neem, bitter orange (for anti-microbial and skin-brightening effects), aloe vera, cucumber, and chandan to calm and refresh the skin. It helps reduce scars, dark spots, acne, and dryness, making it suitable for sensitive and eczema-prone skin. ",
    usage: {
      type: "steps",
      steps: [
        { step: "Wet", description: "Wet the face with water." },
        { step: "Apply", description: "Gently Apply a small amount of facewash." },
        { step: "Massage", description: "Massage gently in circular motions." },
        { step: "Rinse", description: "Rinse thoroughly and pet dry." },
      ]
    },
  },
  {
    id: 5,
    category: "skin-care",
    slug: "jojoba-r-anti-aging-cream",
    images: [
      "/assets/products/anti_aging.jpg",
    ],
    image: "/assets/products/anti_aging.webp",
    name: "Jojoba R Anti Aging Cream",
    size: '30gm Jar',
    suitableFor: "All Skin Types",
    ingredients: "Berberis aq, Oleum Sentali, Cardamom Oil, Cestrum nocturnum....",
    description: "Brightens skin tone, reduces pigmentation and fine lines, and restores youthful firmness for a naturally glowing complexion.",
    features: [
      { icon: "fa-water", title: "Removes Wrinkles", text: "Smooths fine lines and visibly reduces wrinkles for a youthful look" },
      { icon: "fa-hand-dots", title: "Treats Pigmentation", text: "Targets dark spots and uneven tone to reduce pigmentation." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Powered by pure, skin-friendly natural ingredients for safe daily use." },
      { icon: "fa-hand-sparkles", title: "Makes Skin Bright", text: "Revives dull skin and enhances natural brightness for a radiant glow." }
    ],
    composition: [
      { name: "Berberis aq", amount: "6%" },
      { name: "Oleum Sentali", amount: "1%" },
      { name: "Cardamom Oil", amount: "0.5%" },
      { name: "Cestrum nocturnum", amount: "1%" },
      { name: "Arum Metalicum", amount: "0.05%" },
      { name: "Saffron Oil", amount: "1%" },
      { name: "Jojoba Oil", amount: "0.5%" }
    ],
    usage: {
      type: "steps",
      steps: [
        { step: "Cleanse", description: "Wash your face with a mild soap." },
        { step: "Apply", description: "Gently Apply a small amount of anti aging cream and leave it overnight." },
      ]
    },
    about:"Jojoba R Anti-Aging Cream promotes a natural glow and even skin tone while effectively targeting pigmentation and dark spots. Its anti-wrinkle and anti-aging properties help retain skin’s elasticity, reduce fine lines, and improve firmness. Suitable for all skin types, it brightens the complexion by limiting melanin transfer and supports cell renewal for youthful, clearer skin.",

  },
  {
    id: 6,
    category: "cosmetics",
    slug: "jojoba-r-day-care-cream",
    images: [
      "/assets/products/daycare.jpg",
    ],
    image: "/assets/products/daycare.webp",
    banner: "/assets/banners/day_care.png",
    name: "Jojoba R Day Care Cream",
    size: '50gm Jar',
    suitableFor: "All Skin Types",
    description: "Hydrates, protects, and rejuvenates your skin with multi-benefit care that reduces blemishes, soothes damage, boosts elasticity, and leaves your skin smooth, fresh, and glowing all day.",
    features: [
      { icon: "fa-hand-sparkles", title: "Make skin smooth", text: "ELeaves your skin velvety-soft and naturally refined all day." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Powered by gentle, plant-based ingredients for safe daily care." },
      { icon: "fa-hand-dots", title: "Prevent skin patches", text: "Helps even out texture and protects against patchy, uneven skin." },
      { icon: "fa-star-of-life", title: "Removes dullness", text: "Revives tired skin and restores a fresh, radiant glow." }
    ],
    usage: {
      type: "steps",
      steps: [
        { step: "Cleanse", description: "Wash your face with a mild soap." },
        { step: "Apply", description: "Gently Apply the cream in dots all over your face twice a day." },
        { step: "Massage", description: "Massage gently in circular motion." },
      ]
    },
    ingredients: "Jojoba Oil, Glycerin Mono Steareth, Shea Butter, Cetyl Alcohol....",
    composition: [
      { name: "Jojoba Oil", amount: "—" },
      { name: "Glycerin Mono Steareth", amount: "—" },
      { name: "Shea Butter", amount: "—" },
      { name: "Cetyl Alcohol", amount: "—" },
      { name: "Cetyl Palmitate", amount: "—" },
      { name: "Almond Oil", amount: "—" },
      { name: "Crocus Sativa Extract", amount: "—" },
      { name: "Aloe Vera Extract", amount: "—" }
    ],
    about: "Jojoba R Day Care Cream is a multi-purpose skin cream designed to hydrate, nourish, and protect your skin for a healthy, radiant look. It helps prevent signs of aging, reduces acne and blemishes, and soothes sunburn, tan, insect bites, and minor wounds. With exfoliating and antioxidant properties, it removes dead skin cells, neutralizes free radicals, and supports skin renewal. The cream protects the skin's moisture barrier, shields against harmful UV rays, and improves elasticity—leaving your skin smooth, fresh, and glowing every day."

  },

  // Nutraceuticals
  {
    id: 7,
    category: "nutraceuticals",
    slug: "rvibes-fem-immune-capsules",
    images: [
      "/assets/products/fem_immune.jpg",
    ],
    image: "/assets/products/fem_immune.webp",
    banner: "/assets/banners/fem_immune.png",
    name: "RVibes Fem Immune Capsules",
    description: "Advanced multivitamins for women that balance hormones, boost immunity, and support menstrual, bone, skin, hair, and overall wellness by filling essential nutritional gaps.",
    features: [
      { icon: "fa-shield-virus", title: "Boost Immunity", text: "Strengthens the body’s natural defense system to help fight infections effectively." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Formulated with pure herbal extracts for safe, gentle, and holistic wellness support." },
      { icon: "fa-explosion", title: "Promotes Liver Detox", text: "Helps cleanse and support liver function for improved metabolism and overall health." },
      { icon: "fa-scale-balanced", title: "Treats Hormonal Imbalance", text: "Assists in regulating hormonal fluctuations to promote better mood, energy, and reproductive health." }
    ],
    about:"RVibes Fem Immune Capsules are specially formulated multivitamins for women that support overall health and well-being. They help manage anaemia, hormonal balance, menstrual health, skin, hair, nails, bone strength, fertility, pregnancy, mental wellness, and immunity. Enriched with clinically tested natural extracts, essential vitamins, minerals, iron, and antioxidants, they bridge nutritional gaps that diet alone may not fulfill.",
    composition: [
      { name: "Vitamin A", amount: "1300 IU (65%)" },
      { name: "Vitamin B1", amount: "0.8 mg (80%)" },
      { name: "Vitamin B2", amount: "0.88 mg (80%)" },
      { name: "Vitamin B3", amount: "7 mg (58.3%)" },
      { name: "Vitamin B6", amount: "1.6 mg (80%)" },
      { name: "Vitamin B12", amount: "0.8 mcg (80%)" },
      { name: "Vitamin C", amount: "30 mg (75%)" },
      { name: "Vitamin D3", amount: "300 IU (100%)" },
      { name: "Vitamin E", amount: "5 mg (100%)" },
      { name: "Vitamin K1", amount: "25 mcg (100%)" },
      { name: "Zinc", amount: "10 mg (100%)" },

      { name: "Copper", amount: "1.7 mg (85%)" },
      { name: "Iron", amount: "21 mg (100%)" },
      { name: "Magnesium", amount: "100 mg (32.3%)" },
      { name: "Chromium", amount: "30 mcg (100%)" },
      { name: "Phosphorus", amount: "125 mg (20.8%)" },
      { name: "Selenium", amount: "40 mcg (100%)" },
      { name: "Calcium", amount: "250 mg (41.7%)" },
      { name: "Biotin", amount: "20 mcg (100%)" },
      { name: "Iodine", amount: "0.1 mg (66.7%)" },
      { name: "Manganese", amount: "4 mg (100%)" },
      { name: "Folic Acid", amount: "0.08 mg (80%)" }
    ],
    ingredients: "Copper, Iron, Magnesium, Chromium, Phosphorus.....",
    size: "30 Capsules",
    suitableFor: "Women of all ages",
    usage: {
      type: "dosage",
      dosage: [
        "Take 1 capsule twice daily after meals.",
        "Do not exceed recommended dosage.",
        "Or as directed by a healthcare professional."
      ]
    }

  },
  {
    id: 8,
    category: "nutraceuticals",
    slug: "rvibes-daily-vita-plus-tablet",
    images: [
      "/assets/products/daily_vita.jpg",
    ],
    image: "/assets/products/daily_vita.webp",
    banner: "/assets/banners/daily_vita_plus.png",
    name: "RVibes Daily Vita Plus Tablet",
    description: "Provide essential daily vitamins to boost immunity, strengthen bones and muscles, support skin, vision, hair, nails, and overall growth for complete everyday wellness.",
    about: "RVibes Daly Vita Plus Tablets are nutritional multivitamin supplements, rich in essential vitamins like D, A, B, C, and E. They support overall health by boosting immunity, promoting healthy skin, vision, and proper growth. Vitamin D helps treat and prevent rickets, and is vital for strong bones, teeth, muscle function, and wound healing. The supplement also strengthens weak nails and damaged hair. It includes cupric oxide, which supports collagen formation and healthy brain and nervous system function.",
    size: "30 Tablets",
    suitableFor: "All individuals",
    features: [
      { icon: "fa-shield", title: "Boosts Immune Function", text: "Strengthens the body’s natural defense system for better daily protection." },
      { icon: "fa-leaf", title: "Natural Ingredients", text: "Made with safe, plant-based nutrients for effective and gentle wellness support." },
      { icon: "fa-hand-fist", title: "Maintains Muscle Function", text: "Helps improve muscle strength, performance, and overall physical activity." },
      { icon: "fa-hand-sparkles", title: "Promotes healthy Skin", text: "Nourishes the skin from within for a clearer, brighter, and healthier appearance." }
    ],
    usage: {
      type: "dosage",
      dosage: [
        "Take 1 capsule daily with a meal.",
        "Do not exceed recommended dosage.",
        "Or as directed by a healthcare professional."
      ]
    },
    composition: [
      { name: "Calcium Citrate", amount: "22.75 mg" },
      { name: "Vitamin C", amount: "18.5 mg" },
      { name: "Light Magnesium Oxide", amount: "11.85 mg" },
      { name: "Iron (Ferrous Ascorbate)", amount: "8 mg" },
      { name: "Aloe Barbadensis", amount: "7.5 mg" },
      { name: "Vitamin B6", amount: "1.4 mg" },
      { name: "Vitamin B3", amount: "6.5 mg" },
      { name: "Vitamin E", amount: "6 mg" },
      { name: "Glutamic Acid", amount: "5.25 mg" },
      { name: "L-Lysine", amount: "5 mg" },
      { name: "Zinc Monomethionine", amount: "4 mg" },
      { name: "Vitamin B1", amount: "0.5 mg" },
      { name: "Vitamin B2", amount: "0.5 mg" },
      { name: "Vitamin B5", amount: "0.7 mg" },
      { name: "Vitamin B9", amount: "64 mcg" },
      { name: "Vitamin B12", amount: "0.2 mcg" },
      { name: "Vitamin D3", amount: "15 mcg" },
      { name: "Vitamin A", amount: "320 mcg" },
      { name: "Chromium Picolinate", amount: "100 mcg" },
      { name: "Potassium Iodide", amount: "100 mcg" },
      { name: "Cupric Oxide", amount: "150 mcg" },
      { name: "Sodium Bicarbonate", amount: "100 mcg" },
      { name: "Manganese Chloride", amount: "225 mcg" },
      { name: "Sodium Molybdate", amount: "16 mcg" }
    ],
    ingredients: "Calcium Citrate, Vitamin C, Vitamin B, Chromium Picolinate...."

  },
  {
    id: 9,
    category: "nutraceuticals",
    slug: "rvibes-hair-care-tablet",
    images: [
      "/assets/products/hair_care.jpg",
    ],
    image: "/assets/products/hair_care.webp",
    banner: "/assets/banners/hair_care.png",
    name: "RVibes Hair Care Tablet",
    size: "30 Tablets",
    description: "Naturally nourish the scalp and follicles to reduce hair fall, prevent early greying, and support strong, healthy, revitalized hair growth.",
    about: "RVibes Hair Care Tablets promote healthy hair growth by nourishing follicles and preventing baldness, early hair fall, and greying. They improve scalp health, reduce dandruff, dryness, and thinning—without side effects. With hormonal balance and antioxidant support, they boost vitality and encourage new hair growth, especially in early-age baldness.",
    features: [
      { 
        icon: "fa-up-right-and-down-left-from-center", 
        title: "Boost Elasticity", 
        text: "Improves hair elasticity to reduce breakage and enhance strength." 
      },
      { 
        icon: "fa-leaf", 
        title: "Natural Ingredients", 
        text: "Enriched with herbal extracts that nourish the scalp and support healthy hair growth." 
      },
      { 
        icon: "fa-shield-halved", 
        title: "Prevent Hair Loss", 
        text: "Strengthens follicles and reduces early-age hair fall and thinning." 
      },
      { 
        icon: "fa-sparkles", 
        title: "Revive Follicles", 
        text: "Promotes new hair growth by energizing weak and dormant follicles." 
      }
    ],
    composition: [
      { name: "L Isoleucine", amount: "14.6 mg" },
      { name: "Iron", amount: "14.0 mg" },
      { name: "L Glutamic Acid", amount: "61.8 mg" },
      { name: "Vitamin B7 / Biotin / Vitamin H", amount: "30.0 mcg" },
      { name: "L Proline", amount: "16.0 mg" },
      { name: "Copper", amount: "1.35 mg" },
      { name: "L Arginine", amount: "23.5 mg" },
      { name: "L Phenylalanine", amount: "16.0 mg" },
      { name: "Glycine", amount: "12.8 mg" },
      { name: "Vitamin B9 / Folic Acid / Folate", amount: "100.0 mcg" },
      { name: "Magnesium", amount: "50.0 mg" },
      { name: "L-Aspartic Acid", amount: "36.2 mg" },
      { name: "Calcium", amount: "100.0 mg" },
      { name: "L Tryptophan", amount: "3.6 mg" },
      { name: "L Cysteine", amount: "3.9 mg" },
      { name: "L Lysine", amount: "19.6 mg" },
      { name: "L Valine", amount: "14.0 mg" },
      { name: "Manganese", amount: "5.0 mg" },
      { name: "L Serine", amount: "16.0 mg" },
      { name: "DL Methionine", amount: "40.0 mg" },
      { name: "Vitamin E / Tocopherol", amount: "5.0 mg" },
      { name: "Grape Seed Extract", amount: "20.0 mg" },
      { name: "Vitamin B5 / Pantothenic Acid", amount: "5.0 mg" },
      { name: "Vitamin C / Ascorbic Acid", amount: "40.0 mg" },
      { name: "L Histidine", amount: "7.7 mg" },
      { name: "L Threonine", amount: "11.3 mg" },
      { name: "Selenium", amount: "40.0 mcg" },
      { name: "Vitamin B3 / Niacin / Nicotinic Acid", amount: "12.0 mg" },
      { name: "L Leucine", amount: "23.8 mg" },
      { name: "L Tyrosine", amount: "11.9 mg" },
      { name: "L Alanine", amount: "11.9 mg" },
      { name: "Zinc", amount: "10.0 mg" },
      { name: "Isoflavones", amount: "50.0 mg" }
    ],
    ingredients: "Biotin, Iron, Folic Acid, Niacin...",
    usage: {
      type: "dosage",
      dosage: [
        "Take 1 capsule daily with a meal.",
        "Do not exceed recommended dosage.",
        "Or as directed by a healthcare professional."
      ]
    },
    suitableFor: "All Individuals",
  },
  {
    id: 10,
    category: "nutraceuticals",
    slug: "rvibes-ferro-cell-capsules",
    images: [
      "/assets/products/ferrocell.jpg",
    ],
    image: "/assets/products/ferrocell.webp",
    banner: "/assets/banners/ferrocell.png",
    name: "RVibes Ferro Cell Capsules",
    size: "30 Capsules",

    description: "Supports haemoglobin levels and overall health by providing essential iron, folic acid, and key nutrients.",

    about: `RVibes Ferro Cell Capsules are used to treat and prevent various types of anaemia caused by iron, folic acid, or vitamin B12 deficiencies. Ideal during pregnancy, breastfeeding, post-surgery, or in cases of poor nutrient absorption, this supplement supports red blood cell production, boosts haemoglobin, and improves overall wellness.`,

    features: [
      { 
        icon: "fa-droplet", 
        title: "Boost Hemoglobin", 
        text: "Helps improve red blood cell production and haemoglobin levels." 
      },
      { 
        icon: "fa-leaf", 
        title: "Natural Ingredients", 
        text: "Made with gentle natural extracts for safe and effective supplementation." 
      },
      { 
        icon: "fa-bed", 
        title: "Promotes Restful Sleep", 
        text: "Supports relaxation and helps reduce fatigue caused by iron deficiency." 
      },
      { 
        icon: "fa-sliders-h", 
        title: "Supports Hormonal Balance", 
        text: "Helps maintain hormonal health for better daily wellness." 
      }
    ],

    composition: [
      { name: "Ferric Ammonium Citrate (Iron)", amount: "7.5 mcg" },
      { name: "Vitamin B9 (Folic Acid)", amount: "0.5 mg" },
      { name: "Zinc Sulphate Monohydrate", amount: "20.61 mg" },
      { name: "Ginseng Extract", amount: "2%" },
      { name: "Vitamin C (Strawberry Extract)", amount: "18.5 mg" },
      { name: "Vitamin D (Apricot Seed Extract)", amount: "23 mg" },
      { name: "Ginkgo Biloba Extract", amount: "1%" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 capsule twice a day after meals.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 11,
    category: "nutraceuticals",
    slug: "rvibes-milk-thistle-capsules",

    images: [
      "/assets/products/milk_thistle.png",
    ],

    image: "/assets/products/milk_thistle.webp",
    banner: "/assets/banners/milk_thistle.png",

    name: "RVibes Milk Thistle Capsules",
    size: "30 Capsules",

    description:
      "A powerful liver support supplement that aids detoxification, waste elimination, and liver cell regeneration.",

    about: `RVibes Milk Thistle is a powerful liver support supplement that helps detoxify the body, eliminate waste, and support liver cell regeneration. Rich in silymarin, it protects the liver from toxins such as alcohol, chemotherapy, and paracetamol, while reducing inflammation and strengthening the immune system. Its antioxidant properties help prevent liver damage, fibrosis, and cirrhosis.`,

    features: [
      {
        icon: "fa-shield-heart",
        title: "Supports Healthy Liver",
        text: "Protects liver cells from toxins and promotes overall liver health."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Formulated with pure milk thistle extract standardized for 80% silymarin."
      },
      {
        icon: "fa-recycle",
        title: "Promotes Liver Detox",
        text: "Helps remove toxins and supports efficient liver detoxification."
      },
      {
        icon: "fa-seedling",
        title: "Enhances Liver Cell Regeneration",
        text: "Boosts liver cell repair and regeneration for improved liver function."
      }
    ],

    composition: [
      {
        name: "Milk Thistle Extract (Fruit)",
        amount: "400 mg (Standardized for 80% Silymarin)"
      }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 capsule daily with water.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 12,
    category: "nutraceuticals",
    slug: "rvibes-joint-ease-tablet",

    images: [
      "/assets/products/joint_ease.jpg",
    ],

    image: "/assets/products/joint_ease.webp",
    banner: "/assets/banners/joint_ease.png",

    name: "RVibes Joint Ease Tablet",
    size: "30 Tablets",

    description:
      "Supports joint health, flexibility, and mobility with glucosamine, boswellia, and essential nutrients.",

    about: `RVibes Joint Ease Tablet is a dietary supplement formulated to support joint health, flexibility, and mobility. Enriched with Glucosamine Sulphate Potassium, Boswellia Serrata, Vitamin E, and Vitamin C, it helps maintain healthy cartilage and may relieve occasional joint pain and stiffness. Ideal for those with osteoarthritis or joint discomfort, it promotes better movement and comfort.`,

    features: [
      {
        icon: "fa-bone",
        title: "Supports Joints",
        text: "Helps improve joint comfort, strength, and daily mobility."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Formulated with herbal extracts for safe and effective joint support."
      },
      {
        icon: "fa-shield",
        title: "Cartilage Protection",
        text: "Supports healthy cartilage structure and reduces stiffness."
      },
      {
        icon: "fa-person-running",
        title: "Improved Flexibility",
        text: "Enhances ease of movement for better flexibility and comfort."
      }
    ],

    composition: [
      { name: "Glucosamine sulfate (as d-glucosamine sulfate)", amount: "750 mg" },
      { name: "Boswellia serrata - gum resin extract", amount: "300 mg" },
      { name: "Vitamin E (D-alpha-tocopheryl acetate)", amount: "10 mg (RDA: 100%)" },
      { name: "Vitamin C (L-ascorbic acid)", amount: "80 mg (RDA: 100%)" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 tablet per day.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 13,
    category: "nutraceuticals",
    slug: "rvibes-omega-plus-capsule",

    images: [
      "/assets/products/omegaplus.jpg",
    ],

    image: "/assets/products/omegaplus.webp",
    banner: "/assets/banners/omega_plus.png",

    name: "RVibes Omega Plus Capsule",
    size: "30 Capsules",

    description:
      "Supports heart health by reducing inflammation, improving cholesterol levels, and promoting normal blood pressure.",

    about: `RVibes Omega Plus is a heart-health supplement made from flaxseed oil, rich in essential Omega-3, Omega-6, and Omega-9 fatty acids. It supports cardiovascular health by reducing inflammation, regulating heartbeat, and lowering blood pressure. It helps prevent plaque buildup in arteries and improves cholesterol levels, reducing the risk of heart disease and related conditions.`,

    features: [
      {
        icon: "fa-heart-pulse",
        title: "Supports Heart Health",
        text: "Promotes overall cardiovascular wellness and balanced heart function."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Made from pure flaxseed oil rich in essential fatty acids."
      },
      {
        icon: "fa-gauge",
        title: "Promotes Normal Blood Pressure",
        text: "Helps maintain healthy blood pressure levels naturally."
      },
      {
        icon: "fa-arrow-down-wide-short",
        title: "Reduces LDL & Cholesterol",
        text: "Improves cholesterol balance and prevents plaque buildup."
      }
    ],

    composition: [
      {
        name: "Omega-3, Omega-6, Omega-9 Essential Fatty Acids (from Linum Usitatissimum Seed Oil)",
        amount: "500 mg"
      }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 capsule daily twice with water.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 14,
    category: "nutraceuticals",
    slug: "rvibes-neuroboost-b12-tablet",

    images: [
      "/assets/products/neuroboost.jpg",
    ],

    image: "/assets/products/neuroboost.jpg",
    banner: "/assets/banners/neuroboost.png",

    name: "RVibes Neuroboost B12 Tablet",
    size: "30 Tablets",

    description:
      "Enhances brain health, memory, focus, and cognitive function while supporting the nervous system.",

    about: `RVibes Neuroboost B12 supports brain health by enhancing memory, focus, and cognitive function. Its antioxidant properties protect nerve cells from oxidative stress and support healthy neuroreceptor activity. It improves blood circulation, reduces fatigue, and helps with anxiety, restlessness, nervousness, and sleep issues. It also supports mental wellness and improves recall.`,

    features: [
      {
        icon: "fa-brain",
        title: "Supports Nervous System",
        text: "Strengthens nerve function and promotes healthy brain activity."
      },
      {
        icon: "fa-spa",
        title: "Helps Manage Stress",
        text: "Reduces anxiety, restlessness, and fatigue for improved calmness."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Contains essential B-vitamins for safe and effective neuro support."
      },
      {
        icon: "fa-lightbulb",
        title: "Enhances Memory",
        text: "Improves recall, focus, and overall cognitive performance."
      }
    ],

    composition: [
      { name: "Vitamin B1 (Thiamine)", amount: "1.4 mg" },
      { name: "Vitamin B2 (Riboflavin)", amount: "2.0 mg" },
      { name: "Vitamin B3 (Nicotinamide)", amount: "14 mg" },
      { name: "Vitamin B5 (Calcium Pantothenate)", amount: "5.0 mg" },
      { name: "Vitamin B6 (Pyridoxine)", amount: "1.9 mg" },
      { name: "Vitamin B12 (Cobalamin)", amount: "2.2 mcg" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 tablet per day with a meal.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 15,
    category: "nutraceuticals",
    slug: "rvibes-vitamin-d3-tablet",

    images: [
      "/assets/products/vitamin_d3.jpg",
    ],

    image: "/assets/products/vitamin_d3.webp",
    banner: "/assets/banners/vitamin_d3.png",

    name: "RVibes Vitamin D3 Tablet",
    size: "30 Tablets",

    description:
      "Supports calcium absorption, bone strength, immune health, and overall vitality.",

    about: `RVibes Vitamin D3 (600 I.U. per tablet) contains cholecalciferol—the preferred form of Vitamin D3—formulated to support calcium absorption, bone metabolism, and immune health. This nutritional supplement helps maintain strong bones and overall vitality.`,

    features: [
      {
        icon: "fa-shield-virus",
        title: "Enhances Immunity",
        text: "Boosts immune function and supports overall wellness."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Formulated with pure and stabilized Vitamin D3."
      },
      {
        icon: "fa-bone",
        title: "Supports Bone & Joint Health",
        text: "Helps maintain strong bones, joints, and skeletal strength."
      },
      {
        icon: "fa-circle-plus",
        title: "Boost Calcium Absorption",
        text: "Enhances calcium uptake for improved bone mineralization."
      }
    ],

    composition: [
      { name: "Vitamin D3", amount: "600 I.U. (As Stabilized)" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 tablet daily twice with water.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 16,
    category: "nutraceuticals",
    slug: "rvibes-vitamin-d3-k2-mk7-tablet",

    images: [
      "/assets/products/vitamin_d3_k2.png",
    ],

    image: "/assets/products/vitamin_d3_k2.webp",
    banner: "/assets/banners/vitamin_d3_k2.png",

    name: "RVibes Vitamin D3 + K2 as MK7 Tablet",
    size: "30 Tablets",

    description:
      "A synergistic blend of Vitamin D3 and K2 MK7 that supports calcium absorption, bone strength, and cardiovascular health.",

    about: `RVibes Vitamin D3 + K2 as MK7 provides a powerful synergistic blend for enhanced bone and heart health. Vitamin D3 helps maintain optimal calcium absorption and immune health. Vitamin K2 (as MK7) then directs the absorbed calcium precisely to the bones, helping strengthen skeletal structure and supporting cardiovascular wellness.`,

    features: [
      {
        icon: "fa-shield-virus",
        title: "Enhances Immunity",
        text: "Strengthens immune function and supports daily wellness."
      },
      {
        icon: "fa-circle-plus",
        title: "Boost Calcium Absorption",
        text: "Helps the body absorb and utilize calcium more effectively."
      },
      {
        icon: "fa-bone",
        title: "Supports Bone & Joint Health",
        text: "Promotes stronger bones and improves joint flexibility."
      },
      {
        icon: "fa-face-smile-beam",
        title: "Promotes Mood & Energy",
        text: "Supports improved energy levels and mood balance."
      }
    ],

    composition: [
      { name: "Vitamin D3", amount: "600 I.U. (As Stabilized)" },
      { name: "Vitamin K2 (MK7)", amount: "55 mcg" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 1 tablet daily twice with water.",
        "Or as directed by a healthcare professional."
      ]
    },

    suitableFor: "Adults"
  },


  // Herbals
  {
    id: 17,
    category: "herbals",
    slug: "liver-care-tablet",

    images: [
      "/assets/products/liver_care.jpg",
    ],

    image: "/assets/products/liver_care.webp",
    banner: "/assets/banners/liver_care.png",

    name: "Liver Care Tablet",
    size: "40gm",

    description:
      "A powerful herbal formulation that supports liver health, improves digestion, and helps treat liver-related disorders.",

    about: `Liver Care Tablet is a powerful formulation that supports liver health and helps treat conditions like hepatitis, jaundice, cirrhosis, fatty liver, and other liver disorders. It aids liver function, reduces side effects from excessive antibiotic or alcohol use, and relieves symptoms like abdominal pain, loss of appetite, and indigestion. It also helps manage acid reflux, nausea, and post-meal discomfort.`,

    features: [
      {
        icon: "fa-liver",
        title: "Treats Liver Diseases",
        text: "Helps manage fatty liver, hepatitis, jaundice, and liver dysfunction."
      },
      {
        icon: "fa-stomach",
        title: "Relieves Digestive Issues",
        text: "Supports better digestion and reduces post-meal discomfort."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Formulated with potent Ayurvedic herbs for safe and effective liver support."
      },
      {
        icon: "fa-wind",
        title: "Reduces Acidity",
        text: "Helps manage acid reflux, bloating, and digestive imbalance."
      }
    ],

    composition: [
      { name: "Boerhaavia diffusa", amount: "40mg" },
      { name: "Zingiber officinale", amount: "23mg" },
      { name: "Picrorhiza Kurroa", amount: "15mg" },
      { name: "Andrographis paniculata", amount: "28mg" },
      { name: "Piper longum", amount: "22mg" },
      { name: "Solanum nigrum", amount: "17mg" },
      { name: "Onosma bracteatum", amount: "29.50mg" },
      { name: "Rheum emodi", amount: "29.50mg" },
      { name: "Shastriya Yog", amount: "32.20mg" },
      { name: "Cyperus rotundus", amount: "16.80mg" },
      { name: "Curcuma longa", amount: "16.80mg" },
      { name: "Emblica officinalis", amount: "6.67mg" },
      { name: "Terminalia chebula", amount: "6.67mg" },
      { name: "Terminalia belerica", amount: "6.67mg" },
      { name: "Plumbago zeylanica", amount: "15mg" },
      { name: "Holarrhena antidysenterica", amount: "10mg" },
      { name: "Operculina turpethum", amount: "15mg" },
      { name: "Gum acacia", amount: "0.20mg" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 2 tablets twice a day.",
        "Or as prescribed by the doctor."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 18,
    category: "herbals",
    slug: "arthro-care-tablet",

    images: [
      "/assets/products/arthro_care.png",
    ],

    image: "/assets/products/arthro_care.webp",
    banner: "/assets/products/arthro_care.png",

    name: "Arthro Care Tablet",
    size: "40gm",

    description:
      "A highly effective herbal formulation that relieves joint pain, swelling, stiffness, and promotes mobility.",

    about: `Arthro Care Tablet is a highly effective remedy for joint-related issues such as swelling, redness, stiffness, and pain. It supports recovery from old injuries, overexertion, and finger stiffness while promoting joint mobility and overall bone health through a powerful combination of ingredients.`,

    features: [
      {
        icon: "fa-bone",
        title: "Treats All Joint Problems",
        text: "Helps relieve joint pain, swelling, and stiffness for improved movement."
      },
      {
        icon: "fa-seedling",
        title: "Natural Ingredients",
        text: "Formulated with potent herbal ingredients for safe and effective relief."
      },
      {
        icon: "fa-hand",
        title: "Relieves Finger Stiffness",
        text: "Supports flexibility and reduces stiffness in fingers and joints."
      },
      {
        icon: "fa-heart-pulse",
        title: "Cures Bone Issues",
        text: "Strengthens bones and supports long-term joint health."
      }
    ],

    composition: [
      { name: "Shastriya Yog", amount: "50.000 mg" },
      { name: "Strychnos nux vomica", amount: "33.000 mg" },
      { name: "Colchicum luteum", amount: "53.000 mg" },
      { name: "Shastriya Yog", amount: "62.800 mg" },
      { name: "Aconitum ferox", amount: "33.000 mg" },
      { name: "Sodii Biboras", amount: "16.000 mg" },
      { name: "Ricinus communis", amount: "16.000 mg" },
      { name: "Vitex negundo", amount: "16.000 mg" },
      { name: "Zingiber officinale", amount: "15.000 mg" },
      { name: "Piper Nigrum", amount: "15.000 mg" },
      { name: "Apium graveolens", amount: "20.000 mg" },
      { name: "Gum acacia", amount: "0.200 mg" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 2 tablets thrice a day.",
        "Or as prescribed by the doctor."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 19,
    category: "herbals",
    slug: "ashmari-care-tablet",

    images: [
      "/assets/products/ashmari_care.jpg",
    ],

    image: "/assets/products/ashmari_care.webp",
    banner: "/assets/banners/ashmari_care.png",

    name: "Ashmari Care Tablet",
    size: "40gm",

    description:
      "Effective herbal support for kidney stones, urinary discomfort, and urinary tract health.",

    about: `Ashmari Care Tablet is a non-invasive remedy that helps clear obstructions in the kidneys, bladder, and urinary tract. It is effective in managing kidney stones, urinary discomfort, frequent urination, and pain near the kidneys, especially after physical strain. The tablet also supports treatment of urinary tract infections, kidney inflammation, and is beneficial in cases of kidney cysts and other urethral issues.`,

    features: [
      {
        icon: "fa-circle-half-stroke",
        title: "Treats Kidney Stones",
        text: "Helps dissolve and ease the passage of kidney stones naturally."
      },
      {
        icon: "fa-toilet",
        title: "Addresses Urinary Issues",
        text: "Relieves burning sensation, frequent urination, and urinary discomfort."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Enriched with potent Ayurvedic herbs for safe and effective kidney support."
      },
      {
        icon: "fa-droplet",
        title: "Reduces Kidney Inflammation",
        text: "Helps reduce swelling and improves urinary tract health."
      }
    ],

    composition: [
      { name: "Boerhaavia diffusa", amount: "23mg" },
      { name: "Tribulus terrestris", amount: "23mg" },
      { name: "Hordeum vulgare", amount: "23mg" },
      { name: "Shastriya Yog", amount: "20mg" },
      { name: "Crataeva nurvala", amount: "70mg" },
      { name: "Shastriya Yog", amount: "40mg" },
      { name: "Saxifraga Ligilata", amount: "30mg" },
      { name: "Raphanus sativus", amount: "24mg" },
      { name: "Shastriya Yog", amount: "32mg" },
      { name: "Dolichos Biflorus", amount: "6.80mg" },
      { name: "Salsola Baryosma", amount: "8mg" },
      { name: "Zingiber officinale", amount: "30mg" },
      { name: "Gum acacia", amount: "0.20mg" },

      // Liquid Extracts
      { name: "Boerhaavia Diffusa (1:4)", amount: "5ml" },
      { name: "Crataeva nurvala (1:4)", amount: "5ml" },
      { name: "Dolichos Biflorus (1:4)", amount: "5ml" },
      { name: "Pedalium murex (1:4)", amount: "5ml" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take 2 tablets thrice a day.",
        "Or as prescribed by the doctor."
      ]
    },

    suitableFor: "Adults"
  },
  {
    id: 20,
    category: "herbals",
    slug: "likorin-syrup",

    images: [
      "/assets/products/likorin.png",
    ],

    image: "/assets/products/likorin.webp",
    banner: "/assets/banners/likorin_syrup.png",

    name: "Likorin Syrup",
    size: "200ml",

    description:
      "A restorative female tonic that helps manage vaginal discharge, abdominal pain, cramps, menstrual irregularities, and supports reproductive health.",

    about: `Likorin Syrup is a restorative female tonic that helps manage vaginal discharge, backache, pelvic pain, menstrual irregularities, abdominal cramps, and anaemia. It also eases associated anxiety and acts as an effective anti-infective. Formulated to support overall reproductive health and hormonal balance in women.`,

    features: [
      {
        icon: "fa-person-dress",
        title: "Reduces Abdominal Pain",
        text: "Helps relieve lower abdominal pain and discomfort during reproductive issues."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Made with potent herbal extracts for safe and effective female health support."
      },
      {
        icon: "fa-venus",
        title: "Treats Abnormal Menstruation",
        text: "Supports menstrual balance and helps manage irregular periods."
      },
      {
        icon: "fa-hand-holding-heart",
        title: "Relieves Cramps Pain",
        text: "Helps reduce painful cramps and pelvic discomfort."
      }
    ],

    composition: [
      { name: "Saraca indica", amount: "4.00%" },
      { name: "Symplocos racemosa", amount: "4.30%" },
      { name: "Enlophia campestris", amount: "0.55%" },
      { name: "Vryonops laciniosa", amount: "1.60%" },
      { name: "Solanum xanthocarpum", amount: "2.75%" },
      { name: "Diospyros embryopteris", amount: "1.35%" },
      { name: "Crocus sativus", amount: "0.05%" },
      { name: "Magnetite calcined", amount: "2.75%" },
      { name: "Asparagus racemosus", amount: "10.50%" },
      { name: "Asphaltum punjabianum", amount: "2.70%" },
      { name: "Aloe barbadensis", amount: "5.50%" },
      { name: "Tinospora cordifolia", amount: "2.70%" },
      { name: "Vitis vinifera", amount: "5.50%" },
      { name: "Acacia arabica", amount: "5.50%" },
      { name: "Woodfordia floribunda", amount: "1.65%" },
      { name: "Prunus amygdalus", amount: "1.65%" },
      { name: "Phoenix dactylifera", amount: "1.65%" },
      { name: "Purana gud", amount: "45.00%" },
      { name: "Citric Acid", amount: "0.10%" },
      { name: "Sodium Benzoate", amount: "0.20%" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take two teaspoons thrice a day.",
        "Or as directed by the physician."
      ]
    },

    suitableFor: "Women"
  },
  {
    id: 21,
    category: "herbals",
    slug: "likorin-tablet",

    images: [
      "/assets/products/likorin_tablet.png",
    ],

    image: "/assets/products/likorin_tablet.webp",
    banner: "/assets/banners/likorin_tablet.png",

    name: "Likorin Tablet",
    size: "40GM",

    description:
      "A restorative female health formula that supports reproductive wellness, hormonal balance, and relief from menstrual discomfort.",

    about: `Likorin Tablet is a restorative formula for women, designed to support overall reproductive health and hormonal balance. It helps manage conditions such as vaginal discharge, backache, pelvic pain, menstrual irregularities, and abdominal cramps. It also aids in managing anaemia, eases associated anxiety, and acts as an effective anti-infective.`,

    features: [
      {
        icon: "fa-person-dress",
        title: "Reduces Abdominal Pain",
        text: "Relieves lower abdominal pain linked to menstrual or reproductive issues."
      },
      {
        icon: "fa-leaf",
        title: "Natural Ingredients",
        text: "Formulated with powerful herbal extracts for safe female health support."
      },
      {
        icon: "fa-venus",
        title: "Treats Abnormal Menstruation",
        text: "Helps regulate menstrual cycles and reduce irregular bleeding."
      },
      {
        icon: "fa-hand-holding-heart",
        title: "Relieves Cramps Pain",
        text: "Provides effective relief from menstrual cramps and pelvic discomfort."
      }
    ],

    composition: [
      { name: "Ashoka ext. (Saraca asoca) – Bark", amount: "65mg" },
      { name: "Lodhra ext. (Symplocos racemosa) – Bark", amount: "45mg" },
      { name: "Safed Musli ext. (Chlorophytum borivilianum) – Root", amount: "6mg" },
      { name: "Shivlingi (Bryonia laciniosa) – Seed", amount: "18.40mg" },
      { name: "Kantakari ext. (Solanum xanthocarpum) – Whole Plant", amount: "40mg" },
      { name: "Shuddha Tenduka (Diospyros embryopteris) – Fruit Pulp", amount: "20mg" },
      { name: "Gngr Carrot Seed (Daucus carota) – Seed", amount: "20mg" },
      { name: "Vasa ext. (Adhatoda vasica) – Leaf", amount: "20mg" },
      { name: "Nagarmotha ext. (Cyperus rotundus) – Root", amount: "10mg" },
      { name: "Mandur Bhasma (Classical Yog)", amount: "35mg" },
      { name: "Yav Bhasma (Classical Yog)", amount: "10mg" },
      { name: "Shuddha Shilajit (Asphaltum punjabinum) – Ston’s Exudates", amount: "30mg" },
      { name: "Ghrit Kumari (Aloe barbadensis) – Leaf", amount: "8mg" },
      { name: "Giloy (Tinospora cordifolia) – Stem", amount: "8mg" },
      { name: "Shatavari (Asparagus racemosus) – Root", amount: "8mg" },
      { name: "Anar (Punica granatum) – Fruit", amount: "8mg" },
      { name: "Dashmool Kwath (Classical Yog)", amount: "8mg" },
      { name: "Panchvalkal Kwath (Classical Yog)", amount: "8mg" },
      { name: "Kikar Phali (Acacia nilotica) – Phali (pod)", amount: "8mg" },
      { name: "Gum Acacia (Acacia arabica) – Gum", amount: "17.00mg" },
      { name: "Talcum Powder – Mineral", amount: "5.00mg" },
      { name: "Silicon dioxide – Mineral", amount: "1.00mg" },
      { name: "Magnesium Stearate – Chemical", amount: "1.00mg" },
      { name: "Methyl Paraben Sodium – Chemical", amount: "0.50mg" },
      { name: "Propyl Paraben Sodium – Chemical", amount: "0.10mg" },
      { name: "Water (Aqua) – Solvent", amount: "Q.S. to 330mg" }
    ],

    usage: {
      type: "dosage",
      dosage: [
        "Take two tablets a day.",
        "Or as directed by the Physician."
      ]
    },

    suitableFor: "Women"
  }


];

export default products;


export const heroBanners = [
  {
    productSlug: "jojoba-r-anti-dandruff-shampoo",
    image: "/assets/banners/anti_dandruff.png",
    title: "Clean Scalp, Confident You",
    subtitle: "Advanced Scalp Purifying Formula",
  },
  {
    productSlug: "jojoba-r-anti-fungal-cream",
    image: "/assets/banners/anti_fungal.png",
    title: "Clear Skin Starts Here",
    subtitle: "Advanced Formula for Fungal Relief",
  },
  {
    productSlug: "jojoba-r-rejuvenating-face-wash",
    image: "/assets/banners/rejuvenating_face_wash.png",
    title: "Glow That Feels New",
    subtitle: "Skin Renewing & Brightening Formula",
  },
  {
    productSlug: "rvibes-daily-vita-plus-tablet",
    image: "/assets/banners/daily_vita_plus.png",
    title: "Complete Nutrition. Complete You",
    subtitle: "Essential Vitamins for Everyday Health",
  }
];
